module.exports = __webpack_public_path__ + "img/icon-lego-api.f71c8d1d.svg";